import type { SupportedPermissions } from './SupportedPermissions.tsx';
import { useHasPermissions } from './useHasPermissions.tsx';

type ProjectId = string;

// if omitted, Permission is true for all projects
export type Options =
	| {
			// Permission is true for a specific project
			projectId?: ProjectId;
	  }
	| {
			// Permission is true for specific projects
			projectIds?: ProjectId[];
	  }
	| {
			// Permission is true for at least one project (in multi project context)
			anyProject?: boolean;
	  };

/**
 * Creates a hook that returns the permission for the given permission key.
 */
export const createPermissionHook =
	(permissionKey: SupportedPermissions) =>
	(options?: Options): boolean[] => {
		const definedOptions = options ?? {};
		const projectIdInArray =
			'projectId' in definedOptions && definedOptions.projectId
				? [definedOptions.projectId]
				: undefined;
		const projectIds =
			'projectIds' in definedOptions && definedOptions.projectIds
				? definedOptions.projectIds
				: undefined;

		const projectMatch =
			'anyProject' in definedOptions && definedOptions.anyProject === true ? 'any' : 'all';

		const result = useHasPermissions({
			permissionKeys: [permissionKey],
			projectIds: projectIdInArray ?? projectIds,
			projectMatch,
		});

		return [result];
	};
